import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {AuthService} from '../services/core/auth.service';
import {OrganisationsService} from '../services/core/organisations.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  /**
   *
   * @param router
   */
  constructor(private router: Router) {
  }

  /**
   *
   * @param route
   * @param state
   */
  public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const authToken = AuthService.getAuthToken();
    const organisation = OrganisationsService.getOrganisation();
    if(!organisation) {
      return this.router.createUrlTree(['/organisations']);
    }
    else if(!authToken) {
      return this.router.createUrlTree(['/login']);
    }
    return true;
  }
}
